export const storeCustomerAccountsFromApi = customerAccounts => {
  return {
    type: 'STORE_CUSTOMER_ACCOUNTS',
    customerAccounts,
  };
};
